export default __webpack_public_path__ + "static/2-eca873c3aedc6a2f6ce97191dbb127c7.mp4";